




import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ClipboardIcon extends Vue {
  @Prop({ default: false })
  isChecked: boolean

  get clipboardClass(): string {
    return `c-clipboard-icon--${this.isChecked ? 'checked' : 'normal'}`
  }
}
